import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingItems, resetMultipleMessage } from "../../redux/actions";
import { authSelector, itemsSelector } from "../../redux/selectors";
import { useAuth, useSearch, useUrl } from "@ofqual/portal-core/core/hooks";
import { ItemsList } from "./ItemsList";

import { Pager } from "@ofqual/portal-components/components/Pager";
import { FilterControls } from "./FilterControls";
import { ModuleAppBar } from "../ModuleAppBar";
import { Collapse, IconButton, makeStyles } from "@material-ui/core";
import { Alert, Skeleton } from "@material-ui/lab";
import { AppBarButton } from "@ofqual/portal-components/components/SecondaryAppBar";
import { Send, Close } from "@material-ui/icons";
import { SendMultipleMessageDialog } from "../item/activityFeed/dialogs/SendMultipleMessageDialog";
import { UserType } from "../../redux/types";
import { ListTabs } from "./ListTabs";


const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginTop: theme.contentOffsets.AFTER_SECONDARY_APPBAR,
    },
  };
});

export const Items: React.FC = () => {
  const dispatch = useDispatch();
  const items = useSelector(itemsSelector);
  
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [alert, setAlert] = useState<number | undefined>(undefined);

  const { searchParams, navigateToNextPage } = useSearch(useUrl());
  const { userType } = useAuth(authSelector);

 
  useEffect(() => {
    dispatch(loadingItems(searchParams));
  }, [dispatch, searchParams]);

  useEffect(() => {
    if (items.status === "MESSAGES_SENT" && items.multiMessageNumber)
      setAlert(items.multiMessageNumber);
  }, [setAlert, items]);

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <ModuleAppBar>
        <FilterControls />
        {userType === UserType.Ofqual ? (
          <AppBarButton
            size="small"
            onClick={() => setIsDialogOpen(true)}
            color="primary"
            text="New message"
            Icon={Send}
            data-test="multi-message-button"
          />
        ) : null}
      </ModuleAppBar>

      <Collapse in={!!alert}>
        <Alert
          variant="outlined"
          severity="success"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                dispatch(resetMultipleMessage());
                setAlert(undefined);
              }}
            >
              <Close fontSize="inherit" />
            </IconButton>
          }
        >
          Message sent to {items.multiMessageNumber} SoC's
        </Alert>
      </Collapse>
       <ListTabs />
      <Pager state={items} navigateToNextPage={navigateToNextPage} />

      <div>
        {items.hasData ? (
          <ItemsList state={items} />
        ) : (
          <>
            <Skeleton variant="text" height={60} />
            <Skeleton variant="text" height={60} />
            <Skeleton variant="text" height={60} />
            <br />
            <Skeleton variant="rect" height={118} />
          </>
        )}
      </div>
     
      <SendMultipleMessageDialog
        onClose={() => setIsDialogOpen(false)}
        open={isDialogOpen}
      />
    </div>
  );
};
